import { render, staticRenderFns } from "./RocketIcon.vue?vue&type=template&id=acbac6e8&"
import script from "./RocketIcon.vue?vue&type=script&lang=ts&"
export * from "./RocketIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('acbac6e8', component.options)
    } else {
      api.reload('acbac6e8', component.options)
    }
    module.hot.accept("./RocketIcon.vue?vue&type=template&id=acbac6e8&", function () {
      api.rerender('acbac6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/RocketIcon.vue"
export default component.exports